import React from 'react';
import { Router } from '@reach/router';
import { Weather } from '../../screens';
import { CurrentWeather, FiveDayForecast, HourlyForecast } from '../../components';
import './styles.scss';

const AppRouter = () => (
  <Router className="app-router">
    <Weather path="/" />
    <CurrentWeather path="/currentweather" />
    <FiveDayForecast path="/fivedayforecast" />
    <HourlyForecast path="/hourlyforecast" />
  </Router>
);

export default AppRouter;
